import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import {
  OptionsWrapper,
  OptionButton,
  RadioButton,
} from "./subscriptionoptions.styled"

import Tag from "../../tag/tag"

const SubscriptionOptions = ({ options, setActiveOption, activeOption }) => {
  const isSingle = options.length === 1

  const handleSelectSubscription = (index) => {
    setActiveOption(index)
    const obj = options[index]
    segmentEvent("Product Selected", {
      variant: obj?.ui_data?.title,
      core_category: obj?.product_core_category,
      name: obj?.name,
      sku: obj?.sku,
      price: obj?.price,
      product_gender: obj?.product_gender,
      type: "dropdown",
    })
  }

  return (
    <OptionsWrapper className={"multiple-options"}>
      {options.map((option, index) => (
        <OptionButton
          key={index}
          as={isSingle ? "div" : "button"}
          className={
            isSingle || index === activeOption ? "active nova" : "nova"
          }
          onClick={() => handleSelectSubscription(index)}
        >
          <Box mr="16px" pt="5px">
            <RadioButton
              className={isSingle || index === activeOption ? "active" : ""}
            />
          </Box>
          <Box flex="1">
            <Flex
              alignItems="center"
              justifyContent="space-between"
              mb="8px"
              className="gap-[8px]"
            >
              <Flex alignItems="center" flexWrap="wrap" className="gap-2">
                <TextElementNova
                  className={`Body-20-Dia-Strong`}
                  text={option.ui_data?.title}
                />
                {option.ui_data?.savings ? (
                  <Tag
                    data={{
                      line: option.ui_data?.savings,
                      classes: "bg-nova-brand-accent-80 tag",
                    }}
                  />
                ) : null}
              </Flex>
              <Box>
                <TextElementNova
                  className={`Body-20-Dia-Strong`}
                  text={`$${option.price}`}
                />
              </Box>
            </Flex>
            <Flex justifyContent="space-between" mb="8px" className="gap-[8px]">
              <Box>
                <TextElementNova
                  className={`Caption-10-Dia-Normal`}
                  text={option.ui_data?.text_description}
                />
              </Box>
              <Box>
                <TextElementNova
                  className={`Caption-10-Dia-Normal line-through text-nova-transparency-black-70`}
                  text={`$${option.old_price}`}
                />
              </Box>
            </Flex>
            <Box>
              <TextElementNova
                className={`Caption-10-Dia-Normal text-nova-transparency-black-70`}
                text={option.ui_data?.shippingText}
              />
            </Box>
          </Box>
        </OptionButton>
      ))}
    </OptionsWrapper>
  )
}

export default SubscriptionOptions
